module.exports = __webpack_public_path__ + "static/media/icon-web.162123d2.svg";